module.exports = __webpack_public_path__ + "static/cliente_16-b94a5c35758bb657c92b0208a55390b3.png";